enum NavigationTestType {
    ADAPTIVE,
    REGULAR
}

export default NavigationTestType;
